import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { ThreatVectors } from './repository';
import { ThreatVector } from './entity';
import { type ThreatVectorData } from './dto';

export class ThreatVectorsCommands
    implements Commands<ThreatVectors, ThreatVector, ThreatVectorData>
{
    addAll(repo: ThreatVectors, data: ThreatVectorData[]): ThreatVectors {
        data.forEach((threatVectorData) => {
            this.add(repo, threatVectorData);
        });
        return repo;
    }

    add(repo: ThreatVectors, data: ThreatVectorData): ThreatVectors {
        const threatVector = new ThreatVector({
            ...data,
        });
        repo.add(threatVector);
        return repo;
    }

    update(repo: ThreatVectors, entity: ThreatVector): ThreatVector {
        repo.update(entity);
        return entity;
    }

    remove(repo: ThreatVectors, id: string): void {
        repo.remove(id);
    }

    create(
        repo: ThreatVectors,
        data: Omit<ThreatVectorData, 'id'>,
    ): ThreatVector {
        const uuid = new UUID();
        const threatVector = new ThreatVector({
            id: uuid.toString(),
            ...data,
        });
        repo.add(threatVector);
        return threatVector;
    }

    fromJSON(
        entity: ThreatVector[],
        changeCallback: () => void,
    ): ThreatVectors {
        const newThreatVectors = new ThreatVectors(changeCallback);
        entity.forEach((threatVector) => {
            newThreatVectors.add(
                new ThreatVector({
                    ...threatVector,
                }),
            );
        });
        return newThreatVectors;
    }
}
